export default __webpack_public_path__ + "media/images/react_icons/map_marker_tabas-dc0cdd7d9d672c989d4baa0a99c21f04.svg";